import { createSlice } from '@reduxjs/toolkit';
import { redux } from 'Core/redux';

export const STORE_KEY = 'toast';
export const INITIAL_STATE = {
  data: [],
};

export const { reducer, actions } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {
    setToast: (state, action) => {
      state.data.push(action.payload);
    },
    clearAllToast: state => {
      state.data = [];
    },
    removeToast: (state, action) => {
      state.data = state.data.filter(toast => toast.id !== action.payload);
    },
  },
});

export const showToast = toast => dispatch => {
  const toastId = Math.random().toString(36).substr(2, 9);
  const toastData = {
    id: toastId,
    ...toast,
  };

  dispatch(actions.setToast(toastData));
  setTimeout(() => {
    dispatch(actions.removeToast(toastId));
  }, 4000);
};

redux.injectReducer(STORE_KEY, reducer);
